import React, { useEffect, useRef } from "react";
import { useSetState } from "ahooks";
import { useAtom } from "jotai";
import { message } from "antd";
import { SDrawerOrModal, SLowcodeList, STags } from "shj-components";

import { SPUDataAtom } from "@/pages/productClass/components/store.js";
import { getProductSkuSelectList } from "@/services/product.ts";
import { apiData2Table } from "@/utils/data.ts";
import { config } from './config.jsx'

const ChooseSKUModal = (props) => {
  const { open, onClose, onReload, spuData = {} } = props;
  const listRef = useRef();
  const [SPUData, setSPUData] = useAtom(SPUDataAtom)
  const [state, setState] = useSetState({
    selectedRowKeys: [],
  })

  useEffect(() => {
    if (open && spuData.skuIds){
      setState({ selectedRowKeys: spuData.skuIds });
      listRef.current?.setSelectedRowKeys(spuData.skuIds)
    }
  }, [open, spuData]);

  const fetchList = ({ query }) => {
    if (!spuData.productId) return Promise.reject()
    return new Promise((resolve, reject) => {
      getProductSkuSelectList({
        productId: spuData.productId,
        queryShops: true,
        ...query,
      }).then(res => {
        resolve({ records: res })
      }).catch(err => {
        reject(err)
      })
    })
  }

  const onFinish = () => {
    console.log(state.selectedRowKeys);
    if (state.selectedRowKeys.length <= 0) {
      message.error('请选择至少一条SKU');
      return;
    }
    setSPUData((SPUData) => {
        console.log(SPUData)
        return {
          dataSource: SPUData.dataSource.map(item => {
            if (item.id === spuData.id) {
              return {
                ...item,
                skuIds: state.selectedRowKeys
              }
            }
            return item
          })
        }
      }
    )
    onClose();
  }

  const extension = {
    request: { fetchList },
    rowKey: 'id',
    rowSelection: {
      preserveSelectedRowKeys: true,
      selectedRowKeys: state.selectedRowKeys,
      onChange: (selectedRowKeys) => {
        setState({ selectedRowKeys })
      },
    },
    customRender: {
      nameRender(v) {
        return <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      enabledRender(v) {
        return <STags
          itemKey=""
          label={v ? '启用' : '禁用'}
          fontColor={v ? '#00A865' : '#EB3723'}
          bgColor={v ? '#D7F7EA' : '#FFEAE8'}
        />
      },
      argMapRender(v){
        const data = v ? Object.values(v) : []
        return data.map(item => `${item.argName}: ${item.valueName}`).join(', ')
      }
    }
  }

  return <>
    <SDrawerOrModal
      title={'SKU选择'}
      width={900}
      open={open}
      loading={false}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
  </>
}

export default ChooseSKUModal